var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { RoutePath, StakingTab, generateRoutePath } from '../../app/router/config';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import { WalletConnectionType } from '../../types/blockchain';
import { DialogType } from '../../types/dialogs';
import { checkIfWalletAsEnoughCurrency, formatCtaTokenPrice } from '../../utils/balances';
import { useCtaTokenRates } from './use-cta-token-rates';
import { CTA_TOKEN_STAKE_MINT_PASS_USD_PRICE } from './use-my-stakings';
export function useStakingFill(mintPass, weekCountDuration) {
    var t = useI18n().t;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _a = useContext(UserContext), user = _a.user, balances = _a.balances, localWalletAddress = _a.localWalletAddress, reconnectUser = _a.reconnectUser;
    var parseCurrencyQuantity = useContext(CurrencyContext).parseCurrencyQuantity;
    var _b = useCtaTokenRates(), ctaTokenUsdRate7d = _b.ctaTokenUsdRate7d, timestamp = _b.timestamp, secondsBeforeRefetch = _b.secondsBeforeRefetch;
    var _c = useState(mintPass.currentStage + 1), countToCreate = _c[0], setCountToCreate = _c[1];
    var _d = useState(3000), ctaTokenPrice = _d[0], setCtaTokenPrice = _d[1];
    var _e = useState(false), acceptTerms = _e[0], setAcceptTerms = _e[1];
    var _f = useState(undefined), recap = _f[0], setRecap = _f[1];
    var _g = useState(false), notEnoughCurrency = _g[0], setNotEnoughCurrency = _g[1];
    useEffect(function () {
        if (ctaTokenUsdRate7d === 0)
            return;
        var ctaTokenAmount = Math.min(Math.round(CTA_TOKEN_STAKE_MINT_PASS_USD_PRICE / ctaTokenUsdRate7d), 1500);
        setCtaTokenPrice(ctaTokenAmount * (countToCreate - mintPass.currentStage));
    }, [countToCreate, ctaTokenUsdRate7d, mintPass.currentStage]);
    useEffect(function () {
        function getRecap() {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setRecap(undefined);
                            return [4 /*yield*/, gqlSdk.CtaTokenStakeCreatePreview({
                                    input: {
                                        countToCreate: countToCreate - mintPass.currentStage,
                                        weekCountDuration: weekCountDuration,
                                        mintPassUuid: mintPass.uuid,
                                        ctaTokenUsdValueTimestamp: timestamp,
                                    },
                                })];
                        case 1:
                            result = _a.sent();
                            setRecap(result.ctaTokenStakeCreatePreview);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getRecap();
    }, [countToCreate, mintPass, timestamp, weekCountDuration]);
    useEffect(function () {
        if (!(user === null || user === void 0 ? void 0 : user.mpcWalletAddress))
            return;
        var hasEnoughCurrency = checkIfWalletAsEnoughCurrency(user, balances, { address: user.mpcWalletAddress, connectionType: WalletConnectionType.MPC }, localWalletAddress, parseCurrencyQuantity, appEnv.ctaTokenAddress, formatCtaTokenPrice(ctaTokenPrice));
        setNotEnoughCurrency(!hasEnoughCurrency);
    }, [ctaTokenPrice, balances, localWalletAddress]);
    function fillStake() {
        return __awaiter(this, void 0, void 0, function () {
            var error, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setServerLoading(true);
                        error = '';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, gqlSdk.CtaTokenStakeCreate({
                                input: {
                                    mintPassUuid: mintPass.uuid,
                                    weekCountDuration: weekCountDuration,
                                    countToCreate: countToCreate - mintPass.currentStage,
                                    ctaTokenUsdValueTimestamp: timestamp,
                                },
                            })];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        error = t('error.generic');
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(error.length === 0)) return [3 /*break*/, 6];
                        return [4 /*yield*/, reconnectUser()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        setDialogProps({
                            common: {
                                title: error.length > 0 ? t('common.error') : t('common.success'),
                                close: error.length > 0 ? { text: t('common.back'), action: function () { return setDialogProps(undefined); } } : undefined,
                                actions: error.length > 0
                                    ? []
                                    : [{ text: t('common.back'), link: generateRoutePath(RoutePath.STAKING, { tab: StakingTab.MY_STAKINGS }) }],
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error.length > 0 ? error : t('staking.extend.success-message'),
                            },
                        });
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showRecapDialog() {
        if (!recap)
            return;
        setDialogProps({
            common: {
                title: t('staking.fill-staking.confirm-staking'),
                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                actions: [{ text: t('staking.fill-staking.action'), action: fillStake }],
            },
            custom: {
                type: DialogType.STAKING_RECAP,
                countToCreate: countToCreate,
                ctaTokenPrice: ctaTokenPrice,
                ctaTokenUsdRate: ctaTokenUsdRate7d,
                selectedMintPass: mintPass,
                vipPointsToCome: recap.loyaltyPointsIncrease,
            },
        });
    }
    return {
        countToCreate: countToCreate,
        setCountToCreate: setCountToCreate,
        ctaTokenPrice: ctaTokenPrice,
        acceptTerms: acceptTerms,
        setAcceptTerms: setAcceptTerms,
        recap: recap,
        fillStake: fillStake,
        ctaTokenUsdRate7d: ctaTokenUsdRate7d,
        timestamp: timestamp,
        secondsBeforeRefetch: secondsBeforeRefetch,
        showRecapDialog: showRecapDialog,
        notEnoughCurrency: notEnoughCurrency,
    };
}
